<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-row>
        <el-form :inline="true" ref="searchForm" :model="formInline" class="demo-form-inline">
          <el-form-item label="业务系统"  prop="sysId">
            <el-select
              v-model="formInline.sysId"
              placeholder="请选择业务系统"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in sysData"
                :key="index"
                :label="item.systemName"
                :value="item.systemId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计费字段名称" >
            <el-input v-model="formInline.paramName" clearable placeholder="请输入计费字段名称"></el-input>
          </el-form-item>
          <el-form-item class="float-r">
            <el-button size="small" @click="onReset('searchForm')">重置</el-button>
            <el-button size="small" type="primary" @click="queryAll" >查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-card>
    <el-card >
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="handleAdd" icon="el-icon-plus"></el-button>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="60"
          >
        </el-table-column>
        <el-table-column
          label="业务系统"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="唯一标识码"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.fieldId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计费字段名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.fieldName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计费字段映射"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.fieldExpression}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="描述"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.fieldDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="180">
          <template slot-scope="scope">
            <!-- <el-button size="mini" >详情</el-button> -->
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger"  @click="del(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog @close="closeFiled" :title="FiledTitle"  width="450px" center :modal-append-to-body='false' :visible.sync="filedDialog">
      <el-form :model="filedInfo" :rules="filedRule" ref="filedInfo" >
        <el-form-item label="业务系统"  :label-width="formLabelWidth" prop="sysId">
          <el-select
            :disabled="!add"
            v-model="filedInfo.sysId"
            placeholder="请选择业务系统"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in sysData"
              :key="index"
              :label="item.systemName"
              :value="item.systemId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费字段名称" prop="filedName"  :required="required" :label-width="formLabelWidth">
          <el-input style="width: 217px;" placeholder="请输入计费字段名称" maxlength="30" clearable v-model="filedInfo.filedName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="计费字段映射" prop="filedMapping" :required="required" :label-width="formLabelWidth">
          <el-input style="width: 217px;" placeholder="请输入计费字段映射" maxlength="60" clearable v-model="filedInfo.filedMapping" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input type="textarea" style="width: 217px;" maxlength="150" placeholder="请输入描述" v-model="filedInfo.desc"></el-input>
        </el-form-item>
        <el-form-item style="textAlign: center;">
          <el-button @click="filedDialog=false">取 消</el-button>
          <el-button type="primary" v-show="add" @click="addSave('filedInfo')">确 定</el-button>
          <el-button type="primary" v-show="!add" @click="editSave('filedInfo')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
</style>
<script>
export default {
  name: 'Filedfiled',
  data () {
    return {
      formInline: {
        sysId: '',
        paramName: ''
      },
      filedDialog: false,
      add: false,
      required: true,
      tooltip: true,
      formLabelWidth: '140px',
      tableData: [],
      FiledTitle: '',
      filedRule: {
        filedName: [
          { required: true, message: '请输入策略名称', trigger: ['blur', 'change'] },
          { min: 1, max: 30, message: '长度在1至32个字符', trigger: ['blur', 'change'] }
        ],
        sysId: [
          { required: true, message: '请选择业务系统', trigger: ['blur', 'change'] }
        ],
        filedMapping: [{
          validator: (rule, value, callback) => {
            if (value) {
              if ((/^[\u2E80-\u9FFF]+$/).test(value)) {
                callback(new Error('请不要填写汉字'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请不要填写汉字'))
            }
          },
          trigger: ['blur', 'change'],
          required: true
        }]
      },
      filedInfo: {
        sysId: '',
        filedName: '',
        filedId: '',
        filedMapping: '',
        desc: ''
      },
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    queryAll () {
      this.currentPage = 1
      this.query()
    },
    del (index, row) {
      let op = {}
      let _this = this
      op.fieldId = row.fieldId
      this.$confirm('确认是否删除下游计费字段?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          url: _this.$API.config.delProdChargeFieldById,
          // url: 'http://172.16.9.73:5010/agw/prodChargeFieldCtr/delProdChargeFieldById',
          method: 'post',
          data: op
        }).then((response) => {
          _this.query()
          _this.$message.success('下游计费字段删除成功')
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    detail (index, row) {
      this.FiledDialog = true
      this.FiledInfo.filedName = row.filedName
      this.FiledInfo.filedMapping = row.filedEnName
      this.FiledInfo.state = row.state
      this.FiledInfo.filedDesc = row.filedDesc
    },
    handleEdit (index, row) { // 编辑
      this.filedInfo.sysId = Number(row.sysId)
      this.filedInfo.filedMapping = row.fieldExpression
      this.filedInfo.fieldId = row.fieldId
      this.filedInfo.filedName = row.fieldName
      this.filedInfo.desc = row.fieldDesc
      this.FiledTitle = '编辑下游计费字段'
      this.add = false
      this.filedDialog = true
    },
    handleAdd () {
      this.filedDialog = true
      this.FiledTitle = '新增下游计费字段'
      this.add = true
    },
    addSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let id = _this.filedInfo.sysId
          let sysIds = []
          if (id && id !== 0) {
            sysIds.push(id)
          }
          op.fieldName = _this.filedInfo.filedName
          op.fieldExpression = _this.filedInfo.filedMapping
          op.sysIds = sysIds
          op.fieldDesc = _this.filedInfo.desc
          _this.$axios({
            url: _this.$API.config.addProdChargeField,
            // url: 'http://172.16.9.73:5010/agw/prodChargeFieldCtr/addProdChargeField',
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('下游计费字段新增成功!')
            _this.filedDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    editSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.fieldId = _this.filedInfo.fieldId
          op.fieldName = _this.filedInfo.filedName
          op.fieldExpression = _this.filedInfo.filedMapping
          op.fieldDesc = _this.filedInfo.desc
          _this.$axios({
            url: _this.$API.config.editProdChargeField,
            // url: 'http://172.16.9.73:5010/agw/prodChargeFieldCtr/editProdChargeField',
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('下游计费字段编辑成功!')
            _this.filedDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    closeFiled () {
      this.filedInfo = {
        filedName: '',
        filedId: '',
        filedMapping: '',
        desc: ''
      }
      this.add = false
      this.filedDialog = false
      this.$refs['filedInfo'].resetFields()
    },
    /* 重置操作 */
    onReset (formName) {
      this.formInline.sysId = ''
      this.formInline.paramName = ''
    },
    initData () {
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.fieldName = this.formInline.paramName
      op.sysIds = sysIds
      this.$axios({
        url: _this.$API.config.queryProdChargeFieldListByPage,
        // url: 'http://172.16.9.73:5010/agw/prodChargeFieldCtr/queryProdChargeFieldListByPage',
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/config/consumeFiled.vue